import { render } from "./Signin.vue?vue&type=template&id=ca613964&scoped=true"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"

import "./Signin.vue?vue&type=style&index=0&id=ca613964&scoped=true&lang=css"

import exportComponent from "D:\\travel\\travel\\admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca613964"]])

export default __exports__